module.exports = __webpack_public_path__ + "static/case-study-layer-080cd01abfd7c5a0cb70d6b2e3712015.png";